export {
  PropertyAssignment,
  type PropertyAssignmentProps,
} from "./PropertyAssignment";
